var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_492_4",
    "data-name": "Component 492 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.711,
    height: 15.421,
    viewBox: "0 0 7.711 15.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61982",
    "data-name": "Path 61982",
    d: "M3.465,10.855a2.392,2.392,0,0,1,2.39-2.39H8.94V7H5.855a3.855,3.855,0,0,0,0,7.711H8.94V13.246H5.855A2.392,2.392,0,0,1,3.465,10.855Zm3.161.771h6.168V10.084H6.626ZM13.566,7H10.482V8.465h3.084a2.39,2.39,0,0,1,0,4.781H10.482v1.465h3.084a3.855,3.855,0,0,0,0-7.711Z",
    transform: "translate(-7 17.421) rotate(-90)",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/Linked.803410d10523d30818501b77b9d150f1.svg";
export { ForwardRef as ReactComponent };